import { getSorting, stableSort } from 'helpers/sort';
import { formatTranslation } from 'intl';
import { AnalyticsTranslationKeys } from 'intl/keys';
import type { IntlShape } from 'react-intl';
import { SortingOrder } from 'shared/filter/sort/types';
import { DONUT_DASHBOARD_MAX_SLICES } from '../constants/displayLimits';
import type { ChartData } from '../catalog/types';

export { DONUT_DASHBOARD_MAX_SLICES } from '../constants/displayLimits';

type DonutSlice = {
  value: number;
  label: string;
};

function toDonutSlices(data: ChartData): DonutSlice[] {
  return data.values.map((value, index) => ({
    value,
    label: data.labels[index] ?? '',
  }));
}

export function prepareDonutDisplayData(
  data: ChartData,
  intl: IntlShape,
  aggregate: boolean
): ChartData {
  if (!aggregate || data.values.length <= DONUT_DASHBOARD_MAX_SLICES) {
    return data;
  }

  const sorted = stableSort(
    toDonutSlices(data),
    getSorting<DonutSlice>(SortingOrder.desc, 'value')
  );
  const visibleCount = DONUT_DASHBOARD_MAX_SLICES - 1;
  const visible = sorted.slice(0, visibleCount);
  const aggregatedSum = sorted
    .slice(visibleCount)
    .reduce((sum, slice) => sum + slice.value, 0);

  return {
    ...data,
    values: [...visible.map((slice) => slice.value), aggregatedSum],
    labels: [
      ...visible.map((slice) => slice.label),
      formatTranslation(intl, AnalyticsTranslationKeys.legendOther),
    ],
  };
}
